import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { DailyTasksPageTaskName } from '@lean-body/src/route';
import { Task } from '@lean-body/src/domain';
import { Colors } from '../styles';
import { Button, ButtonType, CircleCheckIcon, ProgressBar } from '../atoms';
import { Eye } from '../atoms/icons/eye';
import { DailyTaskSubtask } from '../molecules/daily_tasks_subtask';
import { MealLabel } from '@lean-body/src/domain/meal';
import { MealTaskAnimationIcon } from '../atoms/meal_task_icon';
import { MealTaskBadge } from '../atoms/meal_task_badge';
const SAMPLE_TASK_VALUE = '--';
const DailyTaskInfo = {
    meal: {
        label: '食事',
        unit: 'kcal',
    },
    workout: {
        label: '運動',
        imageSrc: 'assets/images/icons/task_workout.svg',
        unit: 'kcal',
    },
    steps: {
        label: '歩数',
        imageSrc: 'assets/images/icons/task_steps.svg',
        unit: '歩',
    },
    weight: {
        label: '体重',
        imageSrc: 'assets/images/icons/task_weight.svg',
        unit: 'kg',
    },
};
export const DailyTasksListItem = ({ task, mealTask, name, onClick, onClickSubtask, onClickSample, shouldStepPermission, showTaskBadge, isSample = false, classObject, isHidden = false, onToggleVisibility, }) => {
    let current = 0;
    let goal = 0;
    let isComplete = false;
    if (name === DailyTasksPageTaskName.meal && mealTask) {
        current = mealTask.currentTotalCal;
        goal = mealTask.referenceCalMin;
        isComplete = mealTask.isComplete;
    }
    else if (name === DailyTasksPageTaskName.workout) {
        current = Task.roundTaskCalories(task.current);
        goal = Task.roundTaskCalories(task.goal);
        isComplete = task.isComplete;
    }
    else if (name === DailyTasksPageTaskName.steps) {
        current = task.current;
        goal = task.goal;
        isComplete = task.isComplete;
    }
    else if (name === DailyTasksPageTaskName.weight) {
        current = Math.round(task.current * 10) / 10;
        goal = null;
        isComplete = task.isComplete;
    }
    const currentLabel = isSample ? SAMPLE_TASK_VALUE : current.toLocaleString();
    const goalLabel = isSample && goal != null
        ? ` / ${SAMPLE_TASK_VALUE}${DailyTaskInfo[name].unit}`
        : goal != null
            ? ` / ${goal.toLocaleString()}${DailyTaskInfo[name].unit}`
            : '';
    const showProgressBar = name === DailyTasksPageTaskName.meal ||
        name === DailyTasksPageTaskName.workout ||
        name === DailyTasksPageTaskName.steps;
    const handleClick = () => {
        if (isSample) {
            onClickSample();
            return;
        }
        onClick(name);
    };
    const handleClickEye = (e) => {
        if (!onToggleVisibility)
            return;
        e.stopPropagation();
        onToggleVisibility();
    };
    return (React.createElement("div", { className: css(classObject, styles.container, name === DailyTasksPageTaskName.meal && styles.hasSubtask), onClick: handleClick },
        showTaskBadge && React.createElement(MealTaskBadge, { classObject: styles.taskBadge }),
        React.createElement("div", { className: css(styles.taskContainer, name === DailyTasksPageTaskName.meal && styles.taskContainerMeal) },
            React.createElement(CircleCheckIcon, { color: isComplete ? Colors.ProgressGreen : Colors.BackgroundGrayD, classObject: styles.checkIcon, filled: true }),
            DailyTaskInfo[name].imageSrc && React.createElement("img", { src: DailyTaskInfo[name].imageSrc, className: css(styles.image) }),
            name === DailyTasksPageTaskName.meal && React.createElement(MealTaskAnimationIcon, { classObject: styles.mealTaskAnimationIcon }),
            React.createElement("div", { className: css(styles.info) },
                React.createElement("div", { className: css(styles.taskName) }, DailyTaskInfo[name].label),
                React.createElement("div", { className: css(styles.taskProgress, shouldStepPermission && styles.hideProgress) },
                    (name === DailyTasksPageTaskName.meal ||
                        name === DailyTasksPageTaskName.workout ||
                        name === DailyTasksPageTaskName.steps) && (React.createElement(React.Fragment, null,
                        currentLabel,
                        React.createElement("span", { className: css(styles.taskProgressGoal) }, goalLabel))),
                    name === DailyTasksPageTaskName.weight && (React.createElement(React.Fragment, null, isSample || isHidden
                        ? `${SAMPLE_TASK_VALUE}${DailyTaskInfo[name].unit}`
                        : current
                            ? `${current.toLocaleString()}${DailyTaskInfo[name].unit}`
                            : ''))),
                showProgressBar && (goal !== null || isSample) && (React.createElement(ProgressBar, { max: isSample ? 1 : (goal !== null && goal !== void 0 ? goal : 1), current: isSample ? 0 : current, color: Colors.ProgressGreen, trackColor: Colors.ProgressLightGreen, classObject: styles.progressBar, blurEffect: shouldStepPermission })),
                shouldStepPermission && (React.createElement(Button, { isRadius: true, className: css(styles.permissionButton), buttonType: ButtonType.primary }, "\u6B69\u6570\u3092\u53D6\u5F97\u3059\u308B"))),
            name === DailyTasksPageTaskName.weight && onToggleVisibility && (React.createElement(Eye, { close: isHidden, color: Colors.GrayDarkest, classObject: styles.eyeWrap, onClick: handleClickEye }))),
        name === DailyTasksPageTaskName.meal && (React.createElement("div", { className: css(styles.mealSubtaskList) },
            !showTaskBadge && !isSample && (React.createElement(MealTaskBadge, { classObject: styles.taskBadgeSecond, text: "\u8A18\u9332\u3067\u98DF\u3079\u904E\u304E\u9632\u6B62\uFF01" })),
            React.createElement(DailyTaskSubtask, { label: MealLabel.breakfast, isComplete: mealTask === null || mealTask === void 0 ? void 0 : mealTask.hasEatenBreakfast, onClick: isSample ? undefined : onClickSubtask, classObject: styles.mealSubtask }),
            React.createElement(DailyTaskSubtask, { label: MealLabel.lunch, isComplete: mealTask === null || mealTask === void 0 ? void 0 : mealTask.hasEatenLunch, onClick: isSample ? undefined : onClickSubtask, classObject: styles.mealSubtask }),
            React.createElement(DailyTaskSubtask, { label: MealLabel.dinner, isComplete: mealTask === null || mealTask === void 0 ? void 0 : mealTask.hasEatenDinner, onClick: isSample ? undefined : onClickSubtask, classObject: styles.mealSubtask }),
            React.createElement(DailyTaskSubtask, { label: MealLabel.snacking, isComplete: mealTask === null || mealTask === void 0 ? void 0 : mealTask.hasEatenSnacking, onClick: isSample ? undefined : onClickSubtask, classObject: styles.mealSubtask })))));
};
const styles = StyleSheet.create({
    container: {
        cursor: 'pointer',
        width: '100%',
        padding: '24px 16px',
        borderRadius: 14,
        backgroundColor: Colors.White,
        border: `1.5px solid ${Colors.BorderLightGray}`,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        position: 'relative',
    },
    hasSubtask: {
        paddingTop: 20,
        paddingBottom: 16,
    },
    taskContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
    },
    taskContainerMeal: {
        margin: '0 0 6px',
    },
    checkIcon: {
        width: 24,
        height: 24,
    },
    image: {
        width: 54,
        height: 54,
    },
    info: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        position: 'relative',
    },
    taskName: {
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    taskProgress: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '160%',
        letterSpacing: 0.48,
    },
    hideProgress: {
        visibility: 'hidden',
    },
    taskProgressGoal: {
        color: Colors.GrayDarkest,
    },
    eyeWrap: {
        marginLeft: 'auto',
        alignSelf: 'center',
        cursor: 'pointer',
    },
    progressBar: {},
    permissionButton: {
        position: 'absolute',
        padding: 8,
        fontSize: 11,
        width: 106,
        height: 30,
        bottom: 0,
    },
    mealSubtaskList: {
        display: 'flex',
        gap: 8,
        position: 'relative',
    },
    recommendComment: {
        position: 'absolute',
        top: -16,
        right: 0,
        left: 0,
        width: 141,
        margin: '0 auto',
    },
    mealSubtask: {
        flex: 1,
    },
    mealTaskAnimationIcon: {
        width: 54,
        height: 54,
    },
    taskBadge: {
        top: 0,
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    taskBadgeSecond: {
        top: -6,
        left: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
    },
});
